// angular
// 	.module("HeroPRO")
// 	.factory("PipelineMappings", PipelineMappings);

import _ from 'lodash';

/* @ngInject */
export default function PipelineMappingService($filter) {
    function phone(n) {
        let d = String(n).replace(/\D/g, '');
        d = (({
            7: 1,
            10: 1,
        }[d.length]) ? d.match(/\d{1,3}/g) : 0) || [];
        switch (d.length) {
        case 3:
            return `${d[0]}-${d[1]}${d[2]}`;
        case 4:
            return `(${d[0]}) ${d[1]}-${d[2]}${d[3]}`;
        }
        return n;
    }

    const operators = [{
        id: 1,
        value: 3,
        label: 'Contains',
    },
    {
        id: 2,
        value: 1,
        label: 'Is Equal To',
    },
    {
        id: 3,
        value: 6,
        label: 'Greater Than',
    },
    {
        id: 4,
        value: 5,
        label: 'Less Than',
    },
    {
        id: 5,
        value: 6,
        label: 'Is After',
    },
    {
        id: 6,
        value: 5,
        label: 'Is Before',
    },
    ];

    /* API Column ID mapping
	 Status 		= 1, //Result in KBYG, LoanState Everywhere but Leads
	 LeadSource 	= 2, //Lead Source
	 PropertyOwner 	= 3, //PO 1 First Name, Last Name
	 Address 		= 4, //Street Address (KBYG), Address (Everywhere else)
	 City 			= 5, //City
	 Amount 		= 6, //EST Max Amount (KBYG), $ Amount
	 Lessor 		= 7, //Financing Type
	 Date 			= 8, //Expiration Date, Date Initiated
	 FundDate 		= 9, //Est. Fund
	 SalesRep 		= 10 //Sales Rep
	 */

    const columns = {
        status: {
            key: 'Status',
            sort: true,
            val(row) {
                if (!!row.PrequalId) {
                    return 'Lead';
                }
                return row.PipelineStatus;
            },
            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'status',
            },
        },
        finDocStatus: {
            key: 'Status',
            sort: true,
            val(row) {
                return row.PipelineStatus;
            },
            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'finDocStatus',
            },
        },
        leadStatus: {
            key: 'Status',
            sort: true,
            val(row) {
                return row.Status;
            },
            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'leadStatus',
            },
        },
        getPaidStatus: {
            key: 'Status',
            sort: true,
            val(row) {
                return row.PipelineStatus;
            },
            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'fundingRequestStates',
            },
        },
        closedStatus: {
            key: 'Status',
            sort: true,
            val(row) {
                return row.PipelineStatus;
            },
            apiColumnId: 1,
            filter: {
                type: 'predefined',
                key: 'fundingRequestStates',
            },
        },
        propertyOwner: {
            key: 'Property Owner',
            sort: true,
            val(row) {
                return `${row.Owner1FirstName
                } ${
                    row.Owner1LastName}`;
            },
            apiColumnId: 3,
            filter: {
                type: 'propertyOwner',
                operators: [1, 2],
            },
        },
        address: {
            key: 'Address',
            sort: false,
            val(row) {
                return `${row.PropertyAddress1 || ''
                }\n${
                    row.PropertyAddress2 || ''
                }\n${
                    row.PropertyCity || ''
                }${(row.PropertyCity !== undefined && row.PropertyState !== undefined) ? ', ' : ''
                }${row.PropertyState || ''
                } ${
                    row.PropertyZip || ''}`;
            },
            apiColumnId: 4,
            filter: {
                type: 'operator',
                operators: [1, 2],
            },
        },
        strAddress: {
            key: 'Street Address',
            sort: false,
            val(row) {
                return (row.Address !== undefined) ? row.Address.toUpperCase() : '';
            },
            apiColumnId: 4,
            filter: {
                type: 'operator',
                operators: [1, 2],
            },
        },
        city: {
            key: 'City',
            sort: true,
            val(row) {
                return (row.City || '');
            },
            apiColumnId: 5,
            filter: {
                type: 'operator',
                operators: [1, 2],
            },
        },
        appApproved: {
            key: '$ Approved',
            sort: true,
            val(row) {
                return $filter('currency')(row.ApplicationApprovedAmount);
            },
            apiColumnId: 6,
            filter: {
                type: 'currency',
                operators: [2, 3, 4],
            },
        },
        fundingApproved: {
            key: 'Product Amount',
            sort: true,
            val(row) {
                return $filter('currency')(!!row.FundingRequestTotalApproved? row.FundingRequestTotalApproved : row.FundingRequestInitialRequested);
            },
            apiColumnId: 6,
            filter: {
                type: 'currency',
                operators: [2, 3, 4],
            },
        },
        dateInitiated: {
            key: 'Date Initiated',
            sort: true,
            val(row) {
                return $filter('date')(row.CreatedDate, 'MM/dd/yyyy');
            },
            apiColumnId: 8,
            filter: {
                type: 'date',
                operators: [2, 5, 6],
            },
        },
        approvedThrough: {
            key: 'Expiration',
            sort: true,
            val(row) {
                return $filter('date')(row.LoanApprovedThroughDate, 'MM/dd/yyyy');
            },
            apiColumnId: 8,
            filter: {
                type: 'date',
                operators: [2, 5, 6],
            },
        },
        saleRep: {
            sort: true,
            key: 'Sales Rep',
            val(row) {
                return (row.SalesRepFirstName !== undefined ? `${row.SalesRepFirstName} ` : '') +
					(row.SalesRepLastName !== undefined ? row.SalesRepLastName : '');
            },
            apiColumnId: 10,
            filter: {
                type: 'predefined',
                key: 'salesRep',
            },
        },
        leadSalesRep: {
            sort: true,
            key: 'Sales Rep',
            val(row) {
                return (row.RepFirstName !== undefined ? `${row.RepFirstName} ` : '') +
					(row.RepLastName !== undefined ? `${row.RepLastName} ` : '');
            },
            apiColumnId: 10,
            filter: {
                type: 'predefined',
                key: 'salesRep',
            },
        },
        financingType: {
            key: 'Financing Type',
            sort: true,
            val(row) {
                return row.Lessor;
            },
            apiColumnId: 7,
        },
        est: {
            key: 'Est Fund',
            sort: true,
            val(row) {
                return $filter('date')(row.FundingRequestScheduledDisbursementDate, 'MM/dd/yyyy');
            },
            apiColumnId: 9,
            filter: {
                type: 'date',
                operators: [2, 5, 6],
            },
        },
        contact: {
            key: 'Contact',
            sort: true,
            val(row) {
                return `${phone(row.Owner1Phone) || ''
                }\n${
                    row.Owner1Email || ''}`;
            },
        },
        heroId: {
            key: 'HERO ID',
            val(row) {
                return row.HEROId;
            },
        },
        jobNumber: {
            key: 'Job Numbers',
            val(row) {
                let jobnumbers = '';
                for (const number in row.JobIds) {
                    jobnumbers += `${row.JobIds[number]}\n`;
                }
                return jobnumbers;
            },
        },
        leadSource: {
            key: 'Lead Source',
            sort: true,
            val(row) {
                if (!!row.RAApplicationID) {
                    return "Pre-Qual";
                }
                return row.LeadSource;
            },
            apiColumnId: 2,
        },
        jobActions: {
            key: 'Job Actions',
            sort: false,
            apiColumnId: 0,
        },
        searchExpiration: {
            key: 'Expiration',
            sort: true,
            val(row) {
                if (row.PipelineStageId === 2) {
                    return $filter('date')(row.ApplicationExpirationDate, 'MM/dd/yyyy');
                } else if (row.PipelineStageId === 3 || row.PipelineStageId === 4) {
                    return $filter('date')(row.LoanApprovedThroughDate, 'MM/dd/yyyy');
                }
            },
            apiColumnId: 8,
            filter: {
                type: 'date',
                operators: [2, 5, 6],
            },
        },
    };

    return {
        columns,
        mappings: {
            search: [
                'propertyOwner',
                'address',
                'contact',
                'heroId',
                'status',
                'searchExpiration',
                'jobNumber',
            ],
            1: [
                'leadStatus',
                'leadSource',
                'strAddress',
                'city',
                'dateInitiated',
                'leadSalesRep',
                'jobActions',
            ],
            2: [
                'status',
                'address',
                'propertyOwner',
                'approvedThrough',
                'saleRep',
                'jobActions',
            ],
            3: [
                'finDocStatus',
                'address',
                'propertyOwner',
                'financingType',
                'fundingApproved',
                'approvedThrough',
                'saleRep',
                'jobActions',
            ],
            4: [
                'getPaidStatus',
                'address',
                'propertyOwner',
                'financingType',
                'fundingApproved',
                'approvedThrough',
                'est',
                'saleRep',
                'jobActions',
            ],
            5: [
                'closedStatus',
                'address',
                'propertyOwner',
                'financingType',
                'fundingApproved',
                'est',
                'saleRep',
            ],
        },
        getOperators,
    };

    function getOperators(columnName) {
        const result = [];
        if (columns.hasOwnProperty(columnName)) {
            if (columns[columnName].filter !== undefined && columns[columnName].filter.type === 'predefined') {} else if (columns[columnName].filter !== undefined && columns[columnName].filter.type !== 'predefined' &&
    columns[columnName].filter.operators !== undefined) {
                const colOperators = columns[columnName].filter.operators;
                _.each(colOperators, (val) => {
                    result.push(_.findWhere(operators, {
                        id: val,
                    }));
                });
            }
        } else {
            console.log(false, columnName);
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/pipeline/pipelineMappingsConstant.js